import { styled } from '@mui/material/styles';
import { globalZindex } from 'core/common/constants';
import { Container } from 'core/common/ui/ui-kit';
import { applicationSidePaddingPx } from 'core/theme/constants';

export const PageWrapperStyled = styled(Container)`
  z-index: ${globalZindex.content};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  padding: 0 ${applicationSidePaddingPx}px;
  overflow: hidden scroll;
  ${({ theme }) => theme.breakpoints.up('mobile')} {
    padding-top: 100px;
  }

  & > * {
    flex-grow: 1;
    min-height: 0;
  }
`;

export const BodyStyled = styled(Container)<{ $background?: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  padding: 0;
  ${({ $background }) => $background && `background: ${$background};`}
`;
